import { render, staticRenderFns } from "./InboxPage.vue?vue&type=template&id=2c2c339d&scoped=true&"
import script from "./InboxPage.vue?vue&type=script&lang=js&"
export * from "./InboxPage.vue?vue&type=script&lang=js&"
import style0 from "./InboxPage.vue?vue&type=style&index=0&id=2c2c339d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2c339d",
  null
  
)

export default component.exports